export const CHANNEL_TALK_SYNC_BUTTON_VISIBILITY_EVENT =
  'channel-talk:sync-button-visibility';
